import Component from 'gia/Component'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

import { SplitText } from 'gsap/SplitText.js'
gsap.registerPlugin(SplitText);


class Animation extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.i = 0


    this.ref = {
      inview: [],
      split: ''
    }

  }

  mount() {

    // this.lines = new SplitText(this.ref.split, { type: "lines", linesClass: 'line' })
    // this.lines.lines.forEach((item, i) => {

    //     item.dataset.content = item.innerText
    // })

    this.ref.inview.forEach((item, i) => {

      ScrollTrigger.create({
          trigger: item,
          start: "top bottom",
          onEnter: ({progress, direction, isActive}) => {
            item.classList.add("inview")
          },
          once: true
        });
    });
}

  unmount() {




  }


}

module.exports = Animation
